










import ECharts from 'vue-echarts'
import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {DeletePatPna, GetPatPnas, GetPdPressureStatistics, GetPdWeightStatistics} from "@/api/hd"

@Component({
	components: {ECharts}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	addOrEditShow = false
	addOrEditData: any = {}
	loading = false
	tableData = []
	echartsData1: any = {}
	echartsData2: any = {}

	mounted() {
		this.clearEchart()
		this.init()
	}

	columns = [
		{
			title: '透析日期',
			key: 'dialysisDate',
			// render: (h: any, params: any) => {
			// 	return h('span', this.formatDate(params.row.dialysisDate))
			// }
		}, {
			title: '透前收缩压',
			key: 'beforeSbp'
		},{
			title: '透前舒张压',
			key: 'beforeDbp'
		}, {
			title: '透后收缩压',
			key: 'afterSbp'
		},{
			title: '透后舒张压',
			key: 'afterDbp'
		}
	]

	download() {
		(this.$refs.table as any).exportCsv({
			filename: `${this.formatDate(new Date())} ${this.patient.patientName}透析血压统计`
		})
	}

	private async init() {
		let res = await GetPdPressureStatistics({patientId: this.patient.id})

		this.clearEchart()
		res.objects.forEach((item: any) => {
			item.dialysisDate = this.formatDate(item.dialysisDate)
			//X轴点 透析日期
			this.echartsData1.xAxis.data.push(this.formatDate(item.dialysisDate))
			this.echartsData2.xAxis.data.push(this.formatDate(item.dialysisDate))

			this.echartsData1.series[0].data.push(this.formatDate(item.beforeSbp))
			this.echartsData2.series[0].data.push(this.formatDate(item.afterSbp))
			this.echartsData1.series[1].data.push(this.formatDate(item.beforeDbp))
			this.echartsData2.series[1].data.push(this.formatDate(item.afterDbp))

		})
		this.tableData = res.objects
	}


	private clearEchart() {
		this.echartsData1 = {
			title: {
				text: '透前血压'
			},
			tooltip: {
				trigger: 'axis'
			},
			legend: {
				data:['收缩压','舒张压']
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			toolbox: {
				feature: {
					saveAsImage: {}
				}
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: []  //X轴坐标点  需遍历按日期添加
			},
			yAxis: {
				type: 'value'
			},
			series: [
				{
					name:'收缩压',
					type:'line',
					stack: '总量',
					data:[]
				},
				{
					name:'舒张压',
					type:'line',
					stack: '总量',
					data:[]
				},
			]
		};
		this.echartsData2 = {
			title: {
				text: '透后血压'
			},
			tooltip: {
				trigger: 'axis'
			},
			legend: {
				data:['收缩压','舒张压']
			},
			grid: {
				left: '3%',
				right: '4%',
				bottom: '3%',
				containLabel: true
			},
			toolbox: {
				feature: {
					saveAsImage: {}
				}
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: []  //X轴坐标点  需遍历按日期添加
			},
			yAxis: {
				type: 'value'
			},
			series: [
				{
					name:'收缩压',
					type:'line',
					stack: '总量',
					data:[]
				},
				{
					name:'舒张压',
					type:'line',
					stack: '总量',
					data:[]
				},
			]
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/treatmentAnalysis/blood.vue